import {TextureUrlLoader} from '../../../../utils/TextureUrlLoader';
import {Graphics, InteractionEvent, Sprite, Texture} from 'pixi.js';
import {Pivot} from '../../../../utils/Pivot';
import {DrawInstrumentMenuData, DrawInstrumentType} from './DrawInstrumentMenuData';
import {HoverableObject} from '../../../../base/HoverableObject';

export class InstumentButton extends HoverableObject
{
    private icon: Sprite | undefined;
    private treug: Sprite | undefined;
    private back: Graphics;

    constructor(public instrument: DrawInstrumentMenuData, private onClick: (instrument: DrawInstrumentMenuData) => void) {
        super();
        this.back = new Graphics();
        this.selected = false;
        this.addChild(this.back);
        this.init();

    }

    private _selected: boolean = false;

    get selected(): boolean {
        return this._selected;
    }

    set selected(value: boolean) {
        this._selected = value;
        this.back.interactive = this.back.interactiveChildren = !value;

        this.back.clear();
        this.back.beginFill(value ? 0xf65a00 : 0x25282d);
        this.back.drawRoundedRect(-25, -25, 50, 50, 5);
        this.back.endFill();
    }

    onPointerUp(e: InteractionEvent): void {
        super.onPointerDown(e);
        e.stopPropagation();
        this.onClick(this.instrument);
    }

    private async init(): Promise<void> {
        let logoTexture: Texture | null = await TextureUrlLoader.load('/images/drawer/' + this.instrument.type + '.svg');
        this.icon = new Sprite(logoTexture!);
        this.addChild(this.icon);
        Pivot.centerPivot(this.icon);
        if(this.instrument.type == DrawInstrumentType.POINTER){
            this.icon.rotation = -1.05;
            this.icon.x = 1;
            this.icon.y = -3;
        }

        let treugTexture: Texture | null = await TextureUrlLoader.load('/images/drawer/treug.svg');
        this.treug = new Sprite(treugTexture!);
        this.addChild(this.treug);
        Pivot.centerPivot(this.treug);

        this.treug.x = 17;
        this.treug.y = -17;

        this.treug.visible = !!this.instrument.useColor || !!this.instrument.useSize;
    }
}
